import { initLocalOptionsWithDefaultOption } from '../Selectors/Option';

export const rainGutterTypes = initLocalOptionsWithDefaultOption([
  {
    value: 'raingutter',
    identifier: 'raingutter',
    externalIdentifier: 'raingutter',
    variant: 'raingutter',
  },
]);

export const defaultRainGutterType = rainGutterTypes[0];
